import React from 'react';
import { StarIcon } from 'lucide-react';
export function SocialProofBar() {
  return <div className="w-full bg-cream py-4 border-y border-mint/20" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-190">
        <div className="flex items-center gap-1" data-id="element-191">
          {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 text-gold" fill="currentColor" data-id="element-192" />)}
        </div>
        <span className="text-dark font-medium text-sm sm:text-base" data-id="element-193">
          Más de 5,000 emprendedoras satisfechas
        </span>
      </div>
    </div>;
}